import { render, staticRenderFns } from "./CenterDetail.vue?vue&type=template&id=5ff5af10&scoped=true"
import script from "./CenterDetail.vue?vue&type=script&lang=js"
export * from "./CenterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5af10",
  null
  
)

export default component.exports